/**
 * Avatar-Initialen-Lookup. Echte Namens-Initialen wenn User in der users-Liste
 * gefunden wird, sonst Fallback auf Pseudo-Hash aus der UUID.
 */

type UserLite = { user_id: string; name: string };

export function avatarInitials(
  userId: string | null | undefined,
  users: ReadonlyArray<UserLite>,
): string {
  if (!userId) return '?';
  const user = users.find((u) => u.user_id === userId);
  if (user?.name) return nameInitials(user.name);
  return uuidInitials(userId);
}

export function nameInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return (parts[0] ?? '').slice(0, 2).toUpperCase();
  const first = parts[0] ?? '';
  const last = parts[parts.length - 1] ?? '';
  return ((first[0] ?? '') + (last[0] ?? '')).toUpperCase();
}

function uuidInitials(uuid: string): string {
  const hex = uuid.replace(/-/g, '').slice(0, 4);
  const c1 = (Number.parseInt(hex.slice(0, 2), 16) % 26) + 65;
  const c2 = (Number.parseInt(hex.slice(2, 4), 16) % 26) + 65;
  return String.fromCharCode(c1) + String.fromCharCode(c2);
}
